<template>
  <v-bottom-sheet
    :model-value="true"
    persistent
    no-click-animation
    :scrim="false"
    height="100%"
    max-height="100%"
  >
    <div
      class="data-table-header-container pl-4 pr-2 pt-2 data-table header"
      data-testid="data-table-header"
    >
      <div class="left-column">
        <slot>
          <h1 class="table-title">
            {{ title }}
            <v-tooltip activator="parent">
              {{ title }}
            </v-tooltip>
          </h1>
        </slot>
      </div>
      <div class="center-column">
        <slot name="topCenter" />
      </div>
      <div class="right-column">
        <slot name="topRight" />
        <v-btn
          id="data-table-close-button"
          icon="mdi-close"
          variant="text"
          aria-label="Close (Esc)"
          @click="$emit('close')"
        />
        <v-tooltip
          text="Close (Esc)"
          activator="#data-table-close-button"
          open-delay="400"
        />
      </div>
    </div>
    <v-row
      class="data-table"
      style="margin-top: 0;"
      data-testid="data-table-content"
    >
      <v-col>
        <v-skeleton-loader
          v-if="loading"
          type="table-tbody"
          :loading="loading"
        />
        <slot
          v-else
          name="dataView"
        />
      </v-col>
    </v-row>
  </v-bottom-sheet>
</template>

<script lang="ts">
export default {
  name: 'DataTable',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  data() {
    return {
      prevKeyDownHandler: null as null | ((e: KeyboardEvent) => void),
    };
  },
  mounted() {
    this.bindEscapeKey();
  },
  beforeUnmount() {
    this.restoreEscapeKey();
  },
  methods: {
    bindEscapeKey() {
      this.prevKeyDownHandler = window.onkeydown;
      window.onkeydown = (e: KeyboardEvent) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          this.$emit('close');
          // capture the escape key and do not run any existing handlers as long as the feature grid is open
          return;
        }
        if (typeof this.prevKeyDownHandler === 'function') {
          this.prevKeyDownHandler(e);
        }
      };
    },
    restoreEscapeKey() {
      if (this.prevKeyDownHandler) {
        window.onkeydown = this.prevKeyDownHandler;
      } else {
        window.onkeydown = null;
      }
      this.prevKeyDownHandler = null;
    },
  },
};
</script>

<!-- eslint-disable vue-scoped-css/no-parsing-error -->
<style scoped lang="scss">
.data-table {
  background-color: white;

  .table-title {
    font-size: 18px;
    color: main.$npGray;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  &.header {
    max-height: 100px;
  }
}

.data-table-header-container {
  display: grid;
  grid-template-columns: 1fr fit-content(100%) 1fr;
  align-items: center;
  gap: 16px;
  width: 100%;

  .left-column {
    display: flex;
    align-items: center;
    min-width: 0;
    justify-self: start;
    max-width: 100%;
  }

  .center-column {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    justify-self: stretch;
  }

  .right-column {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    white-space: nowrap;
    justify-self: end;
  }

  @media (max-width: 605px) {
    max-height: 165px;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    gap: 8px;

    .left-column,
    .right-column {
      justify-self: center;
    }

    .center-column {
      justify-self: stretch;
    }
  }
  @media (max-width: 475px) {
    max-height: 150px;
  }
  @media (max-width: 445px) {
    max-height: 170px;
  }
}
</style>
